// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__gx11o","title":"CardHeader_title__5VHVJ"};